import React from 'react';

/**
 * Groups buttons with consistent spacing — matches Atlaskit ButtonGroup.
 *
 * @param {Object} props - Component props.
 * @param {ReactNode} props.children - Child elements.
 * @returns {ReactElement}
 */
const CustomButtonGroup = ({ children }) => (
    <div className = 'custom-btn-group'>
        {children}
    </div>
);

export default CustomButtonGroup;
